import { checkIfNumeric } from './number';

export type Currency = 'EUR';

export function formatCurrency(
  amount: string | number,
  currency: Currency = 'EUR',
  minimumFractionDigits = 0,
  maximumFractionDigits = 0,
) {
  // Only check if amount is not a number
  if (!checkIfNumeric(amount)) {
    throw new Error('Not a number');
  }

  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return formatter.format(Number(amount));
}

export function formatCurrency_legacy(amount: string | number, postfix = '') {
  if (!amount && amount !== 0) {
    return null;
  }

  amount = Number(amount);

  const locale = 'de-DE';

  return amount ? amount.toLocaleString(locale) + postfix : 0 + postfix;
}
